export const styles = {
  header: { padding: '0 50px' },
  wrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    padding: '50px',
    backgroundColor: '#fff',
    '& .MuiFormControl-root': {
      width: '160px',
    },
  },
  countrySelector: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  wrapperClientSelect: {
    marginLeft: 20,
  },
  result: {
    marginLeft: '100px',
    fontSize: '22px',
    marginBottom: '10px',
  },
  exportButton: {
    alignSelf: 'flex-start',
  },
  table: {
    display: 'flex',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/NetPromoterScore/styles.js